<div class="kt-container  kt-grid__item kt-grid__item--fluid">

    <!--Begin::App-->
    <div class="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">

        <!--Begin:: App Aside Mobile Toggle-->
        <button class="kt-app__aside-close" id="kt_user_profile_aside_close">
            <i class="la la-close"></i>
        </button>

        <!--End:: App Aside Mobile Toggle-->

        <!--Begin:: App Aside-->
        <div class="kt-grid__item kt-app__toggle kt-app__aside" id="kt_user_profile_aside">

            <!--begin:: Widgets/Applications/User/Profile4-->
            <div class="kt-portlet kt-portlet--height-fluid-">
                <div class="kt-portlet__body">

                    <!--begin::Widget -->
                    <div class="kt-widget kt-widget--user-profile-4">
                        <div class="kt-widget__head">
                            <div class="kt-widget__media">
                                <img class="kt-widget__img kt-hidden-" *ngIf="isImage"
                                    src="{{assetsPath + userBasicInfo.image}}" alt="image">
                                <img class="kt-widget__img kt-hidden-" *ngIf="!isImage"
                                    src="/assets/media/users/default.jpg" alt="image">
                                <div
                                    class="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
                                    AD
                                </div>
                            </div>
                            <div class="kt-widget__content">
                                <div class="kt-widget__section">
                                    <a href="#" class="kt-widget__username">
                                        {{ userBasicInfo.displayName}}
                                    </a>
                                    <div class="kt-widget__button">
                                        <span class="btn btn-label-warning btn-sm">Aktif Gönüllü</span> <br
                                            *ngIf="userBasicInfo.isAlumni"><br *ngIf="userBasicInfo.isAlumni">
                                        <span class="btn btn-label-brand btn-sm"
                                            *ngIf="userBasicInfo.isAlumni">Mezun</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="kt-widget__body">
                            <a [routerLink]="['/my-profile']" class="kt-widget__item kt-widget__item--active">
                                Genel Bilgiler
                            </a>
                            <a [routerLink]="['/update-my-basic-information']" class="kt-widget__item">
                                Temel Bilgilerimi Güncelle
                            </a>
                            <a [routerLink]="['/update-my-role-settings']" class="kt-widget__item">
                                Gönüllülük Alanlarım
                            </a>
                            <a [routerLink]="['/update-my-password']" class="kt-widget__item">
                                Şifremi Değiştir
                            </a>
                            <a [routerLink]="['/my-profession-list']" class="kt-widget__item">
                                Kariyer Bilgilerim
                            </a>
                            <a [routerLink]="['/my-education-list']" class="kt-widget__item">
                                Eğitim Bilgilerim
                            </a>
                            <a [routerLink]="['/judge-form']" class="kt-widget__item">
                                Jürilik Bilgi Formu
                            </a>
                            <a [routerLink]="['/referee-form']" class="kt-widget__item">
                                Hakemlik Bilgi Formu
                            </a>
                        </div>
                    </div>

                    <!--end::Widget -->
                </div>
            </div>

            <!--end:: Widgets/Applications/User/Profile4-->

            <!--Begin:: Portlet-->
            <div class="kt-portlet">
                <div class="kt-portlet__body">
                    <div class="kt-widget1 kt-widget1--fit">
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Başvurularım</h3>
                                <span class="kt-widget1__desc">Aktif başvuru sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-brand">0</span>
                        </div>
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Rozetlerim</h3>
                                <span class="kt-widget1__desc">Rozet sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-success">0</span>
                        </div>
                    </div>
                </div>
            </div>

            <!--end:: Portlet-->
        </div>

        <!--End:: App Aside-->

        <!--Begin:: App Content-->
        <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
            <div class="kt-portlet__body" *ngIf="!userBasicInfo.isVerified">

                <!--begin::Section-->
                <div class="kt-section">
                    <div class="kt-section__content">
                        <div class="kt-demo">
                            <div class="kt-demo__preview">
                                <div class="alert alert-danger" role="alert">
                                    <div class="alert-text">
                                        <h4 class="alert-heading">Lütfen hesabınızı aktifleştirin!</h4>
                                        <hr>
                                        <p>Etkinliklere başvurabilmeniz için hesabınızı aktifleştirmeniz gerekmektedir! Aktifleştirme maili almak için lütfen aşağıdaki butona basınız.</p>
                                        <hr>
                                        <button type="submit" class="btn btn-primary btn-bold" (click)="sendActivationCode()">Mail gönder!</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--end::Section-->
            </div>
            <div class="row">
                <div class="col-xl-12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title">Profil <small>Genel Bilgiler</small></h3>
                            </div>
                        </div>
                        <form class="kt-form kt-form--label-right">
                            <div class="kt-portlet__body">
                                <div class="kt-section kt-section--first">
                                    <div class="kt-section__body">
                                        <div class="row">
                                            <div class="col-lg-9 col-xl-6">
                                                <h3 class="kt-section__title kt-section__title-sm">Hesap Bilgileri:</h3>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-xl-3 col-lg-3 col-form-label">Email</label>
                                            <div class="col-lg-9 col-xl-6 col-form-label">
                                                <span>{{ userBasicInfo.email }}</span>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-xl-3 col-lg-3 col-form-label">Telefon</label>
                                            <div class="col-lg-9 col-xl-6 col-form-label">
                                                <span>{{ userBasicInfo.phone }}</span>
                                            </div>
                                        </div>
                                        <div class="form-group row kt-margin-t-10 kt-margin-b-10">
                                            <label class="col-xl-3 col-lg-3 col-form-label"></label>
                                            <div class="col-lg-9 col-xl-6">
                                                <button type="button"
                                                    class="btn btn-label-danger btn-bold btn-sm kt-margin-t-5 kt-margin-b-5"
                                                    (click)="showReminderModal()">Hesabımı
                                                    sil</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="kt-separator kt-separator--border-dashed kt-separator--portlet-fit kt-separator--space-lg">
                                </div>
                                <div class="kt-section kt-section--first">
                                    <div class="kt-section__body">
                                        <div class="row">
                                            <div class="col-lg-9 col-xl-6">
                                                <h3 class="kt-section__title kt-section__title-sm">Eğitim Bilgileri:
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th>Okul</th>
                                                        <th>Bölüm/Departman</th>
                                                        <th>Öğrenim türü</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let education of educationList;">
                                                        <td>{{ education.schoolName }}</td>
                                                        <td>{{ education.departmant}}</td>
                                                        <td>
                                                            {{ getEducationLevel(education.level)}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="kt-separator kt-separator--border-dashed kt-separator--portlet-fit kt-separator--space-lg">
                                </div>
                                <div class="kt-section kt-section--first">
                                    <div class="kt-section__body">
                                        <div class="row">
                                            <div class="col-lg-9 col-xl-6">
                                                <h3 class="kt-section__title kt-section__title-sm">Çalışma Bilgileri:
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th>Kurum/Firma</th>
                                                        <th>Pozisyon</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let profession of professionList;">
                                                        <td>{{ profession.company }}</td>
                                                        <td>{{ profession.position }}</td>
                                                        <td>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--End:: App Content-->
    </div>

    <!--End::App-->
</div>
<div class="modal fade" id="reminder">
    <div class="modal-dialog" role="document" style="max-width: 800px">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Hesabını sil</h5>
                <button type="button" class="close" (click)="hideReminderModal()" aria-label="Close">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    Hesabınızı sildiğinizde kişisel bilgileriniz ve işlem bilgileriniz hem veri tabanımızdan hem
                    portalımızın üyelik bölümünden silinecektir. Bu doğrultuda geçmişte yaptığınız işlemlerle ilgili
                    herhangi bir bilgiye erişemeyeceğinizi size bildirmek isteriz.
                </p>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary font-weight-bold" (click)="hideReminderModal()">Hesabımın
                    silinmesini onaylamıyorum</button>
                <button type="button" class="btn btn-success font-weight-bold" (click)="deleteMyAccount()">Hesabımın
                    silinmesini onaylıyorum</button>
            </div>
        </div>
    </div>
</div>